import React, { useEffect, useState } from "react";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import CustomTable from "../../components/styledComponent/styledTable";
import {
  deleteOrders,
  listAllOrders,
} from "../../server/purchaseOrderServices";
import TableActions from "../../components/tableAction/tableActions";
import { ShowNotification } from "../../components/notification/notification";
import DeleteModal from "../../components/styledComponent/deleteModal";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../contexts/appContext";
import { salesOrderStatus } from "../../components/styledComponent/styledElements";
import { MdVerified } from "react-icons/md";
import { PRIMARY_THEME } from "../../constants/constant";

export default function PurchaseOrderPage() {
  const column = [
    {
      title: "Id",
      dataIndex: ["purchase_order", "id"],
      key: "id",
      width: 100,
    },
    {
      title: "Customer Name",
      dataIndex: ["customer", "name"],
      key: "customer_name",
      render: (_, value) => (
        <div className="flex items-center gap-2">
          {value.customer.name}
          {value.customer.is_vip && (
            <MdVerified size={18} color={PRIMARY_THEME} />
          )}
        </div>
      ),
    },
    {
      title: "Staff Name",
      dataIndex: ["staff", "name"],
      key: "staff_name",
    },
    {
      title: "Quotation Id",
      dataIndex: ["purchase_order", "quotation_id"],
      key: "quotation_id",
      onCell: (record) => ({
        onClick: (e) => {
          e.stopPropagation();
          navigate(`/quotation/${record.purchase_order.quotation_id}`);
        },
      }),
    },
    {
      title: "Grand Total",
      dataIndex: ["purchase_order", "grand_total"],
      key: "grand_total",
    },
    {
      title: "Status",
      dataIndex: ["purchase_order", "status"],
      key: "status",
      render: (value) => salesOrderStatus(value),
    },
    {
      title: "Created on",
      dataIndex: ["purchase_order", "created_at"],
      key: "created_at",
    },
    {
      key: "actions",
      width: 100,
      render: (text, record) => (
        <TableActions
          showDelete={userRole === "Admin" || purchaseOrderPermission?.delete}
          onClickDelete={(e) => {
            e.stopPropagation();
            setDeleteId(record.purchase_order.id);
            setShowDeletePopup(true);
          }}
        />
      ),
    },
  ];
  const { startLoading, stopLoading, user } = useAppContext();
  const navigate = useNavigate();

  const [tableData, setTableData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [refetch, setRefetch] = useState(false);
  var userRole = user?.role;
  var purchaseOrderPermission = user?.access?.purchase_order;

  const fetchOrders = () => {
    startLoading();
    listAllOrders()
      .then((res) => {
        setTableData(res.data);
        setRefetch(false);
      })
      .catch((err) => console.log("Error on fetching products", err))
      .finally(() => stopLoading());
  };
  useEffect(() => {
    fetchOrders();
  }, [refetch]);
  const handleDeleteProduct = () => {
    deleteOrders(deleteId)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Sales Order Deleted Successfully ",
        });
      })
      .finally(() => {
        setDeleteId(null);
        setShowDeletePopup(false);
        setRefetch(true);
      });
  };
  return (
    <div>
      <StyledContentCard title={"Sales Order"}>
        {showDeletePopup && (
          <DeleteModal
            showDelete={showDeletePopup}
            onCancel={() => {
              setDeleteId(null);
              setShowDeletePopup(false);
            }}
            onsubmit={handleDeleteProduct}
          />
        )}
        <CustomTable
          data={tableData}
          columns={column}
          rowKey="id"
          onRow={(record) => {
            return {
              onClick: () => {
                navigate(`/sales-order/${record.purchase_order.id}`);
              },
              className: "clickable",
            };
          }}
        />
      </StyledContentCard>
    </div>
  );
}
